<template>
    <div class="home" id="panorama-root">
        <div v-if="loading" class="loading">
            <div class="load-container"></div>
        </div>
        <div v-else>
            <div v-if="photoBase64" class="camera-photo" @pointerdown="close">
                <div class="photoFrame" @pointerdown.stop>
                    <img class="photo" :src="photoBase64"/>
                    <div class="tool">
                        <div class="icon" @pointerdown="close">
                            <img src="../../public/icon/close.svg"/>
                        </div>
                        <div class="icon" @pointerdown="download">
                            <img src="../../public/icon/downLoad.svg"/>
                        </div>
                    </div>

                </div>
            </div>
            <div class="camera" @pointerdown="photograph">
                <img src="../../public/icon/camera.svg"/>
            </div>
            <div class="camera back" @pointerdown.stop="toHome">
                <img src="../../public/icon/back.svg"/>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src

import * as THREE from "three";
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";
import {MusicManager} from "@/manager/musicManager";
import {ImageManager} from "@/manager/ImageManager";

export default {
    name: 'HomeView',
    data() {
        return {
            scene: null,
            renderer: null,
            animate: null,
            loading: true,
            controls: null,
            photoBase64: null,
            obj: null
        }
    },
    created() {
        ImageManager.clearImages()
    },
    async mounted() {
        console.log('123123')
        let obj = JSON.parse(localStorage.getItem('worldPath'))
        if (!obj) {
            this.$router.replace('/')
            return
        }
        this.obj = obj
        console.log(obj)
        var scene = new THREE.Scene();
        var camera = new THREE.PerspectiveCamera(65, window.innerWidth / window.innerHeight, 0.1, 1000);
        var renderer = new THREE.WebGLRenderer({preserveDrawingBuffer: true});
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(window.innerWidth, window.innerHeight);
        renderer.domElement.style.position = 'fixed'
        renderer.domElement.style.top = '0'
        document.getElementById('panorama-root').appendChild(renderer.domElement);
        THREE.Cache.enabled = false;
        this.scene = scene
        this.renderer = renderer
        var geometry = new THREE.SphereGeometry(3, 64, 32);
        new THREE.TextureLoader().load(obj.image, (texture) => {
            var material = new THREE.MeshBasicMaterial({
                map: texture,
                side: THREE.BackSide // 使材质双面渲染
            });
            material.needsUpdate = true;
            var sphere = new THREE.Mesh(geometry, material);
            scene.add(sphere);
            this.loading = false
        })

        camera.position.z = 2.5;
        var controls = new OrbitControls(camera, document.getElementById('panorama-root'));
        this.controls = controls
        controls.enablePan = false;
        controls.mouseButtons = {
            LEFT: THREE.MOUSE.LEFT,   // 左键
            MIDDLE: THREE.MOUSE.MIDDLE, // 中键
            RIGHT: null               // 禁用右键
        };
        controls.autoRotate = true
        controls.autoRotateSpeed = 0.3
        // 设置OrbitControls的缩放范围
        controls.minPolarAngle = Math.PI / 3; // 最小俯仰角（30度）
        controls.maxPolarAngle = Math.PI / 1.9; // 最大俯仰角（90度）
        controls.minDistance = 1; // 最小距离，确保摄像机不会进入球体内部
        controls.maxDistance = 3;  // 最大距离，确保摄像机不会离球体太远
        window.addEventListener('resize', () => {
            // 更新相机的纵横比
            camera.aspect = window.innerWidth / window.innerHeight;
            camera.updateProjectionMatrix();
            // 更新渲染器的大小
            renderer.setSize(window.innerWidth, window.innerHeight);
        });
        let self = this
        this.animate = function animate() {
            requestAnimationFrame(animate);
            if (!self.photoBase64) {
                controls.update();
                renderer.render(scene, camera);
            }
        }

        this.animate();
    },
    methods: {
        toHome() {
            this.$router.replace('/')
        },
        photograph() {
            // 获取渲染器的 canvas 数据
            setTimeout(() => {
                this.controls.enabled = false
                const dataURL = this.renderer.domElement.toDataURL('image/png');
                console.log(dataURL)
                this.photoBase64 = dataURL
            }, 1000)
            MusicManager.play()
        },
        close() {
            this.controls.enabled = true
            this.photoBase64 = null
        },
        download() {
            const downloadLink = document.createElement('a');
            downloadLink.href = this.photoBase64;
            downloadLink.download = `${this.obj.name}-某处风景-${Date.now()}.png`;
            // 触发下载
            downloadLink.click();
        },
        cleanupScene() {
            // 遍历场景中的所有对象并释放资源
            this.scene.traverse((object) => {
                if (!object.isMesh) return;

                // 释放几何体
                object.geometry.dispose();

                // 释放材质和纹理
                if (object.material.isMaterial) {
                    this.cleanMaterial(object.material);
                } else {
                    // 如果有多个材质
                    for (const material of object.material) this.cleanMaterial(material);
                }
            });

            // 销毁渲染器
            this.renderer.dispose();
            this.renderer.domElement = null;

            // 移除事件监听器

            // 停止动画循环
            cancelAnimationFrame(this.animate);
        },
        cleanMaterial(material) {
            console.log(material)
            if (material.map) material.map.dispose();
            if (material.lightMap) material.lightMap.dispose();
            if (material.bumpMap) material.bumpMap.dispose();
            if (material.normalMap) material.normalMap.dispose();
            if (material.specularMap) material.specularMap.dispose();
            if (material.envMap) material.envMap.dispose();

            material.dispose();
        },
    },
    beforeDestroy() {
        console.log(123)
        this.cleanupScene()
    }
}
</script>
<style lang="less" scoped>
.home {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 20;
    display: flex;

    .camera-photo {
        width: 100%;
        height: 100vh;
        display: flex;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 5;
        background: rgba(255, 255, 255, 0.3);
        box-shadow: 0 8px 32px 0 rgba(251, 251, 252, 0.37);
        backdrop-filter: blur(7.5px);
        -webkit-backdrop-filter: blur(7.5px);

        .photoFrame {
            box-sizing: content-box;
            margin: auto;
            width: 80%;
            padding: 15px 15px 0 15px;
            background-color: #FFFFFF;

            .photo {
                user-select: none;
                width: 100%;
                height: 100%;
            }

            .tool {
                width: 100%;
                height: 5vh;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .icon {
                    cursor: pointer;
                    padding: 5px;
                    width: 20px;
                    height: 20px;
                    border-radius: 5px;
                    background-color: #f1f1f1;

                    &:hover {
                        box-shadow: 0 0 9px 2px #f1f1f1;
                    }

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }


    }

    .back {
        right: 80px !important;
    }

    .camera {
        cursor: pointer;
        user-select: none;
        pointer-events: auto;
        z-index: 4;
        position: fixed;
        bottom: 20px;
        right: 20px;
        width: 50px;
        height: 50px;
        padding: 10px;
        box-sizing: border-box;
        border-radius: 10px;

        &:hover {
            box-shadow: 0 0 9px 2px #f1f1f1;
        }

        background-color: #FFFFFF;

        img {
            user-select: none;
            pointer-events: auto;
            width: 100%;
            height: 100%;
        }
    }

    .loading {
        z-index: 3;
        width: 40vw;
        margin: auto;

        .load-container {
            width: 12vh;
            height: 12vh;
            background-image: url("../assets/floding.png");
            background-size: contain;
            background-repeat: no-repeat;

            margin: 50px auto;
            -webkit-animation: rotateplane 3s infinite ease-in-out;
            animation: rotateplane 3s infinite ease-in-out;
        }

        @-webkit-keyframes rotateplane {
            0% {
                -webkit-transform: perspective(180px) rotateX(0deg) rotateY(0deg)
            }
            50% {
                -webkit-transform: perspective(180px) rotateX(180deg) rotateY(179.9deg);
            }
            100% {
                -webkit-transform: perspective(180px) rotateY(-179.9deg);
            }
        }

        @keyframes rotateplane {
            0% {
                transform: perspective(180px) rotateX(0deg) rotateY(0deg);
                -webkit-transform: perspective(180px) rotateX(0deg) rotateY(0deg)
            }
            50% {
                transform: perspective(180px) rotateX(180deg) rotateY(179.9deg);
                -webkit-transform: perspective(180px) rotateX(180deg) rotateY(179.9deg);
            }
            50% {
                transform: perspective(180px) rotateY(-179.9deg);
                -webkit-transform: perspective(180px) rotateY(-179.9deg);
            }
        }

    }
}
</style>
